module.exports = __webpack_public_path__ + "static/media/PrintBlueLogo.63ead8aa.svg";